import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/pro-regular-svg-icons";

interface PaymentEditActionCellProps {
    data: any;
}

interface PaymentEditActionCellState {
    paymentId: number;
}

class PaymentEditActionCell extends React.Component<PaymentEditActionCellProps> {
    state: PaymentEditActionCellState;

    constructor(props: PaymentEditActionCellProps) {
        super(props);
        this.state = {
            paymentId: this.props.data.data.id,
        };
    }

    componentDidMount() {}

    render() {
        return (
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex">
                    <Link
                        title="Edit"
                        className={(false ? "disabled " : "") + "icon-btn"}
                        to={{
                            pathname: "/PaymentsV2Page",
                            state: {
                                id: this.state.paymentId.toString(),
                            },
                        }}
                    >
                        <FontAwesomeIcon icon={faPen} />
                    </Link>
                </div>
            </div>
        );
    }
}

export default PaymentEditActionCell;
